module.exports = __webpack_public_path__ + "static/img/range5.84b15373.png";